// @flow strict
import { pipe, prop, groupBy, sort, toPairs } from 'ramda';
import type { Skill } from './ald-types'

export const groupSkillsByStrand: (Skill[]) => Array<[string, Skill[]]> = pipe(
  // sort by indicator
  sort((a, b) => a.strandOrder - b.strandOrder),
  // group by strand. resultant type: { "strand1": [skills], "strand2": [skills]}
  groupBy(prop('strandName')),
  // convert object to array: [["strand1", [skills]], ["strand2", [skills]]]
  toPairs
);

export const toKebabCase = (str: string): string => {
  return str.toLowerCase().replace(/,/g,'').replace(/\s+/g, '-');
};

export const sanitizeIndicator = (str: string): string => {
  return toKebabCase(str).replace(/\./g, '-');
};
